import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./DocumentCenterDocViewerTab.module.css";
import { PdfViewer } from "../../../../../../common/components";
import { DocumentService } from "../../../../../../api";
import { isNonEmptyArray } from "../../../../../../common/utils";
import { useApi, useResizeObserver } from "../../../../../../common/hooks";
import DocumentHeader from "./DocumentHeader";

function DocumentCenterDocViewerTab({ isFile, previousPath, redirectUrl, selectedDocument, status }) {
	const docId = selectedDocument?.id;
	const [containerRef, { height: containerHeight }] = useResizeObserver();
	const [pageDimensions, setPageDimensions] = useState([]);
	const [numberOfPages, setNumberOfPages] = useState(0);
	const [content, setContent] = useState([]);
	const [currentPage, setCurrentPage] = useState(0);
	const [zoom, setZoom] = useState(0);
	const scrollRef = useRef(null);
	const { call: getPage } = useApi(DocumentService.getPage);
	const { call: getDocumentPhysicalDetails } = useApi(DocumentService.getDocumentPhysicalDetails);

	useEffect(() => {
		setPageDimensions([]);
		setNumberOfPages(0);
		setContent([]);
		setCurrentPage(0);
		setZoom(0);
		if (docId) {
			getDocumentPhysicalDetails({ docId })
				.then((data) => {
					const { pageDimensions: dimensions, numberOfPages: pages, pageHigh, pageWidth } = data;
					setPageDimensions(
						isNonEmptyArray(dimensions)
							? dimensions
							: Array.from({ length: pages }, () => ({ width: pageWidth, height: pageHigh }))
					);
					setNumberOfPages(pages);
				})
				.catch((err) => console.error(err));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [docId]);

	const handleGetPage = useCallback(
		(page) => {
			if (docId && !content.some((c) => c.page === page)) {
				getPage({ docId }, { page })
					.then((image) => {
						setContent((prev) => [...prev, { page, image: URL.createObjectURL(image) }]);
					})
					.catch((err) => console.error(err));
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[content, docId]
	);

	const handleChangePage = useCallback(
		(page) => {
			if (scrollRef.current && isNonEmptyArray(pageDimensions)) {
				let top = 0;
				for (let i = 0; i < page; i++) {
					top += ((pageDimensions[i]?.height || 0) * zoom) / 100;
				}
				scrollRef.current.scrollTo({ top, behavior: "auto" });
			}
			setCurrentPage(page);
		},
		[pageDimensions, zoom]
	);

	return (
		<div className={styles.container}>
			<DocumentHeader
				docId={docId}
				isFile={isFile}
				numberOfPages={numberOfPages}
				page={currentPage}
				pageDimensions={pageDimensions}
				pdfContainerWidth={containerRef?.current?.offsetWidth}
				previousPath={previousPath}
				redirectUrl={redirectUrl}
				status={status}
				zoom={zoom}
				onChangePage={handleChangePage}
				onZoomChange={setZoom}
			/>
			<div ref={containerRef} className={styles.container__body}>
				<PdfViewer
					className={styles.pdfViewer}
					content={content}
					height={containerHeight}
					numberOfPages={numberOfPages}
					pageDimensions={pageDimensions}
					scrollRef={scrollRef}
					width="100%"
					zoom={zoom || 100}
					onGetPage={handleGetPage}
					onSetPage={setCurrentPage}
				/>
			</div>
		</div>
	);
}

export default DocumentCenterDocViewerTab;
